import { cn } from "./utils";

/**
 * Base focus styles for all focusable elements.
 * This is the SINGLE SOURCE OF TRUTH for focus styling.
 *
 * These styles are applied globally via CSS in the portal app.
 * Components can also use this class string directly if needed.
 *
 * Keep in sync with: frontend/apps/portal/app/styles/app.css
 */
export const focusStyles = cn(
  "focus-visible:border-ring focus-visible:ring-ring/50 transition-[color,box-shadow] outline-none focus-visible:ring-[3px]",
);
